import { useState } from 'react';
import { forEach, is, map } from 'ramda';
import { useFormContext } from 'react-hook-form';
import { useAnalytics } from '@@app/context/analytics-context.js';
import { extraMessageErrorSaveDocument } from '../extra/extraMessageErrorSaveDocument';
import { useProcess } from '@fasstech/oip-starter-utils/app';

const useDownloadDocumentsContainer = ({
  downloadMutation,
  setDocumentsDownloaded,
  getMiddleText
}) => {
  const [displayModal, setDisplayModal] = useState(false);
  const [loader, setLoader] = useState({
    isLoading: false,
    name: ''
  });
  const [hasError, setHasError] = useState(false);
  const { trackButtonClick } = useAnalytics();

  const [errorSaveDocumentModalMessage, setErrorSaveDocumentModalMessage] = useState('');

  const { context } = useProcess();

  const handleLoadDocuments = (filesInfo, name) => {
    trackButtonClick({
      code: 'DOWNLOAD_DOCUMENTS',
      label: getMiddleText('DOWNLOAD_DOCUMENTS_BUTTON')
    });

    const formattedFileInfo = map(
      (fileInfo) => ({
        bundleTag: fileInfo.bundleTag,
        fileName: fileInfo.label,
        featureName: fileInfo.featureName,
        productCode: fileInfo.productCode,
        filePath: fileInfo.filePath
      }),
      filesInfo
    );

    setHasError(false);
    setLoader({
      isLoading: true,
      name
    });

    downloadMutation(
      {
        filesInfo: formattedFileInfo
      },
      async (ok, error, res) => {
        setLoader({
          isLoading: false,
          name
        });

        if (ok && !error) {
          const {
            urls = [],
            fileType = '',
            errorDuringUpload = false
          } = res;
          if (errorDuringUpload) {
            setErrorSaveDocumentModalMessage(extraMessageErrorSaveDocument(context));
          }

          forEach((url) => {
            window.open(url, '_blank');
          }, urls);
          if (is(Function, setDocumentsDownloaded) && fileType === 'zip') {
            setDocumentsDownloaded(true);
          }
        } else {
          setDocumentsDownloaded(false);
          setHasError(true);
          setErrorSaveDocumentModalMessage(
            'Suite indisponibilité technique, les documents et/ou les informations produits ne sont pas disponibles. Veuillez réessayer ultérieurement. Nous mettons tout en œuvre pour résoudre le problème. En nous excusant de la gêne occasionnée.'
          );
        }
      }
    );
  };

  const methods = useFormContext();

  return {
    methods,
    setDisplayModal,
    handleLoadDocuments,
    loader,
    displayModal,
    hasError,
    errorSaveDocumentModalMessage,
    setErrorSaveDocumentModalMessage
  };
};

export default useDownloadDocumentsContainer;
